const RouteEndpoint = {
  HOMEPAGE: "/",
  RFJS_BOOK: "/react-for-job-seekers",
  COURSE_LIST: "https://www.udemy.com/user/qaifi-khan/",
  BLOGS: "https://medium.com/@qaifikhan",
};
Object.freeze(RouteEndpoint);

export default RouteEndpoint;
